import React, { useState, useCallback } from 'react';
import styled, { keyframes } from 'styled-components';
import {
  colors,
  fonts,
  breakpoints,
  radii,
  headingStyle,
  containerStyle,
  parseFaq,
} from '../annuaire/designSystem';

const slideDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Section = styled.section`
  background-color: ${colors.bleu};
  border-radius: 30px;
  margin: 0 16px;
  padding: 48px 0;

  @media (min-width: ${breakpoints.mobile}) {
    margin: 0 32px;
    padding: 64px 0;
  }
`;

const Container = styled.div`
  ${containerStyle}
`;

const Heading = styled.h2`
  ${headingStyle}
  color: ${colors.white};
  font-size: 1.5rem;
  margin-bottom: 32px;

  @media (min-width: ${breakpoints.mobile}) {
    font-size: 2.125rem;
  }
`;

const EmphasisLime = styled.span`
  color: ${colors.vert};
`;

const FAQItem = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 20px 0;

  &:last-child {
    border-bottom: none;
  }
`;

const FAQQuestion = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding: 12px 0;
  color: ${colors.white};
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 1rem;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
  }
`;

const FAQToggle = styled.span`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.vert};
  border-radius: 50%;
  transition: transform 0.2s ease;
  color: ${colors.bleuFonce};
  font-weight: 700;
  flex-shrink: 0;
  font-size: 1.1rem;

  ${(p) => p.$open && 'transform: rotate(45deg);'}
`;

const FAQAnswer = styled.div`
  padding: 16px 0 0;
  color: rgba(255, 255, 255, 0.85);
  font-family: ${fonts.body};
  font-size: 0.95rem;
  line-height: 1.65;
  animation: ${slideDown} 0.2s ease;
`;

export default function ShopFAQ({ shop }) {
  const details = shop.details || {};
  const seo = details.seo || {};
  const faqText = seo.faq_seo || '';

  // Parse FAQ from "Q1: ... R1: ..." format
  const faqs = parseFaq(faqText);

  const [openIndex, setOpenIndex] = useState(null);

  const toggle = useCallback((index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  }, []);

  if (faqs.length === 0) return null;

  return (
    <Section>
      <Container>
        <Heading>
          Questions <EmphasisLime>fr&eacute;quentes</EmphasisLime>
        </Heading>
        {faqs.map((faq, i) => (
          <FAQItem key={i}>
            <FAQQuestion onClick={() => toggle(i)}>
              <span>{faq.question}</span>
              <FAQToggle $open={openIndex === i}>+</FAQToggle>
            </FAQQuestion>
            {openIndex === i && <FAQAnswer>{faq.reponse}</FAQAnswer>}
          </FAQItem>
        ))}
      </Container>
    </Section>
  );
}
